// extracted by mini-css-extract-plugin
module.exports = {"comment_textarea":"dece2e673c--comment_textarea--1Lfsi"};